import api from "@/infrastructure/api/axios";
export const featureFlagRepository = {
    async getRuntime() {
        const response = await api.get("/feature-flags/runtime");
        return response.data;
    },
    async getAdminFlags() {
        // A global platform route — the backend rejects X-Org-Id on it outright,
        // regardless of which org (if any) the acting super-admin has selected.
        const response = await api.get("/feature-flags", {
            orgContext: "global",
        });
        return response.data;
    },
    async updateGlobalValue(flagId, enabled) {
        await api.patch(`/feature-flags/${flagId}/global`, { enabled });
    },
    async upsertOrgOverride(flagId, organizationId, enabled) {
        await api.patch(`/feature-flags/${flagId}/organizations/${organizationId}`, {
            enabled,
        });
    },
};
export default featureFlagRepository;
